import { DateTime } from 'luxon';
import { AUTH_STORAGE_KEY } from 'src/adapters/AuthStore';

type claims = {
  claims: {
    orgId: string | undefined;
    iat: number;
    exp: number;
    userId: string | undefined;
    roleIds: [string] | undefined;
    scope: [string] | undefined;
    activatedAt: string;
  };
};

export default function setupLocalAuth() {
  const current = DateTime.local();
  // eslint-disable-next-line
  let roles = process.env.REACT_APP_LOCAL_BACKEND_ROLES;
  const localStorageUser: claims = {
    claims: {
      // eslint-disable-next-line
      orgId: process.env.REACT_APP_LOCAL_BACKEND_ORG,
      iat: current.minus({ minutes: 1 }).valueOf(),
      exp: current.plus({ hours: 2 }).valueOf(),
      // eslint-disable-next-line
      userId: process.env.REACT_APP_LOCAL_BACKEND_USER,
      roleIds: JSON.parse(roles || '[]'),
      scope: JSON.parse(roles || '[]'),
      activatedAt: current.minus({ days: 2 }).toISO(),
    },
  };
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(localStorageUser));
}
